import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import BloodTesting from "../../../components/BloodTesting/BloodTesting";
import MismatchBloodGrouping from "../../../components/BloodTesting/mismatch/bloodGrouping";
import MismatchSerology from "../../../components/BloodTesting/mismatch/serology";
import { withRouter } from "../../../utils/withRouter";
import SearchDonation from "../../../components/BloodCollection/SearchDonation";
import { Tabs } from "../../../components/Tabs";
import CheckboxQuestionnaire from "../../../components/Input/CheckboxQuestionnaire";
import { getStorage } from "../../../utils/storage";
import accessMenus from "../../../utils/accessMenu";
import { ROLE_PACKAGING } from "../../../constants/ROLES";
import { defineRole } from "../../../utils/handleAccessRoles";
import SerologyAlinity from "../../../components/BloodTesting/alinity";
import NewTransfer from "../../../components/BloodCollection/Packaging/Transfer";
import ListPackaging from "../../../components/BloodCollection/Packaging/List";
import AutomaticTest from "../../../components/BloodTesting/AutomaticTest";
import Qualys from "../../../components/BloodTesting/qualys";

class BloodTestingScreen extends React.Component {
  state = {
    user: {},
    searchType: "manualTest",
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  handleCheck(type, value) {
    this.setState({ [type]: value });
  }
  render() {
    const {
      canReadBloodTest,
      canConfirmBloodTestBloodGrouping,
      canConfirmBloodTestSerology,
    } = accessMenus();

    const canReadPackaging = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_PACKAGING,
      operation: "read",
    });

    const canCreatePackaging = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_PACKAGING,
      operation: "create",
    });

    let tabOptions = [];

    // if (canReadReport) {
    //   tabOptions.push(
    //     canReadReport && {
    //       title: language[this.props.defaultLanguage].dashboard,
    //       data: <BloodTestDashboard />,
    //     }
    //   );
    // }

    tabOptions.push({
      title: language[this.props.defaultLanguage].search_by_donation,
      data: (
        <div className="card">
          <div className="col-md-6">
            <CheckboxQuestionnaire
              answers={[
                {
                  key: "searchType",
                  value: "manualTest",
                  onPress: () => this.handleCheck("searchType", "manualTest"),
                },
                {
                  key: "searchType",
                  value: "qualysTest",
                  onPress: () => this.handleCheck("searchType", "qualysTest"),
                },
              ]}
              checked={this.state.searchType}
            />
            {this.state.searchType === "manualTest" && (
              <div className="card-bold">
                <SearchDonation
                  filters={this.props.filters}
                  showResultModal
                  navigationUrl="/dashboard/donations"
                />
              </div>
            )}
            {this.state.searchType === "qualysTest" && (
              <div className="card-bold">
                <AutomaticTest />
              </div>
            )}
          </div>
        </div>
      ),
    });

    // if (canReadBloodTest) {
    //   tabOptions.push({
    //     title: language[this.props.defaultLanguage].blood_test_blood_grouping,
    //     data: <BloodTestStatistics type="bloodGroupingTested" />,
    //   });
    // }

    // if (canReadBloodTest) {
    //   tabOptions.push({
    //     title: language[this.props.defaultLanguage].blood_test_serology,
    //     data: <BloodTestStatistics type="serologyTested" />,
    //   });
    // }

    // if (canReadBloodTest) {
    //   tabOptions.push();
    // }

    if (canReadPackaging || canCreatePackaging) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].packaging,
        data: (
          <Tabs
            mountOnEnter
            unmountOnExit={false}
            options={[
              canCreatePackaging && {
                title: language[this.props.defaultLanguage].new_record,
                data: (
                  <div className="card">
                    <div className="card-body">
                      <NewTransfer status="received" />
                    </div>
                  </div>
                ),
              },
              canReadPackaging && {
                title: language[this.props.defaultLanguage].historical_data,
                data: (
                  <ListPackaging
                    status={["received", "transferred"]}
                    type="SAMPLE"
                  />
                ),
              },
            ]}
          />
        ),
      });
    }

    if (canReadBloodTest) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].blood_test_results,
        data: <BloodTesting />,
      });
    }

    if (canReadBloodTest) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].qualys_test,
        data: <Qualys />,
      });
    }

    if (canReadBloodTest) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].serology_test,
        data: <SerologyAlinity />,
      });
    }

    if (canConfirmBloodTestBloodGrouping) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].mismatch_blood_grouping,
        data: <MismatchBloodGrouping />,
      });
    }
    if (canConfirmBloodTestSerology) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].mismatch_serology,
        data: <MismatchSerology />,
      });
    }
    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Tabs options={tabOptions} mountOnEnter unmountOnExit={false} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(BloodTestingScreen));
